// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import config from '../../../../share/config';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import error from '../../../../common/nodejs/errors';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import session from '../../../../share/session';
import util from "../../../../share/util/utils";

/** 各フェーズ定義 */
const PHASE = {
  START: "start",
  MAINTENANCE_START_CONFIRMATION: "maintenanceStartConfirmation",
  MAINTENANCE_END_CONFIRMATION: "maintenanceEndConfirmation",
  MAINTENANCE_MODE_START: "maintenanceModeStart",
  MAINTENANCE_MODE_END: "maintenanceModeEnd",
  START_SURVEILLANCE: "startSurveillance",
  START_DISPLAY: "startDisplay",
  END_SURVEILLANCE: "endSurveillance",
  END_DISPLAY: "endDisplay",
  MOUNTED_CONFIRMATION: "mountedConfirmation",
  SENSOR_VALUE: "sensorValue",
  START_FAILED: "startFailed",
  SPEED_ERROR_START: "speedErrorStart",
  SPEED_ERROR_END: "speedErrorEnd",
  CANCEL: "cancel",
  END_FAILED: "endFailed",
  SENSOR_ABNORMALITY: "sensorAbnormality",
  ERROR: "error"
};

/** STANDBY API レスポンス */
const RESPONSE_STATUS = {
  START: 'start',
  END: 'end',
};

/** API type定義 */
const API_TYPE = {
  STANDBY: 'standby',
  READ_SENSOR_VALUE: 'readSensorValue',
  READ: 'read',
  SEC_ACCESS: 'secAccess',
  EXECUTE_END: 'executeEnd',
  EXECUTE_START: 'executeStart',
  TERMINATE: 'terminate',
  START: 'start',
  DISPOSE: 'dispose'
};

export default {
  name: "requirement117",
  data() {
    return {
      phase: PHASE.START,
      isLoading: false,
      waitTime: 5000,
      isCompletedNds: false, //NonDefaultSession遷移完了フラグ
      modal_requirement_117: false
    };
  },
  props: {
    i18nWsKey: { type: String, default: "", required: true },
    workSupportId: { type: Number, default: "", required: true }
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),

    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.SPEED_ERROR_START:
        case PHASE.SPEED_ERROR_END:
        case PHASE.START_FAILED:
        case PHASE.END_FAILED:
        case PHASE.SENSOR_ABNORMALITY:
        case PHASE.ERROR:
        case PHASE.CANCEL:
          return "danger";
        case PHASE.MAINTENANCE_START_CONFIRMATION:
        case PHASE.MAINTENANCE_END_CONFIRMATION:
        case PHASE.MAINTENANCE_MODE_START:
        case PHASE.MAINTENANCE_MODE_END:
        case PHASE.START_SURVEILLANCE:
        case PHASE.START_DISPLAY:
        case PHASE.END_SURVEILLANCE:
        case PHASE.END_DISPLAY:
        case PHASE.MOUNTED_CONFIRMATION:
        case PHASE.SENSOR_VALUE:
        default:
          return "secondary";
      }
    }
  },

  methods: {
    ...mapActions("auth", ["logout", "resetSession"]),

    /** 初期化処理 */
    init() {
      this.modal_requirement_117 = true;
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit("close-wizard");
      this.modal_requirement_117 = false;
    },

    /** その他エラー発生時の表示 */
    showUnexpectedError() {
      // 異常終了：エラー表示
      this.phase = PHASE.ERROR;
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
     */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /** DTC読出し */
    async start() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.STANDBY,
        };

        // 初期処理（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              this.waitTime = response.data.user_data.wait_time;
              this.successResponseStandby(response.data.user_data.response_status);
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 共通エラー
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * NonDefaultSession遷移
     * @param {boolean} isStart 開始時処理かどうか
     */
    async doStart(isStart) {
      try {
        this.isLoading = true;
        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.START,
        };

        // 初期処理（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (!response) {
          // ESLint対応(ネストは5つまで)の為、ここでreturn
          return;
        }

        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            this.isCompletedNds = true;
            // セキュリティアクセス判定
            await this.doSecAccess(isStart);
            break;
          case config.STATUS_WSP_FAILED:
            // 失敗
            // 各エラー表示
            switch (response.data.async_code) {
              case error.WSP_117_EXCESSIVE_WHEEL_SPEED:
                if (isStart) {
                  // 開始時車輪速超過表示
                  this.phase = PHASE.SPEED_ERROR_START;
                } else {
                  // 終了時車輪速超過表示
                  this.phase = PHASE.SPEED_ERROR_END;
                }
                this.errorClose();
                break;
              case error.WSP_GENERAL_ERROR:
                this.isCompletedNds = false;
                if (isStart) {
                  // 共通エラー
                  this.showUnexpectedError();
                } else {
                  // メンテナンスモード終了不可表示
                  this.phase = PHASE.END_FAILED;
                }
                break;
              default:
                this.isCompletedNds = false;
                // 該当のエラーコードが存在しない場合、共通エラー
                this.showUnexpectedError();
                break;
            }
            break;
          default:
            this.showUnexpectedError();
            break;
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** センサ値判定 */
    async sensorValueJudgement() {
      try {
        this.isLoading = true;
        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.READ_SENSOR_VALUE,
        };

        // 初期処理（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // セッション移行済判定
              await this.sessionStatusJudgement();
              break;
            case config.STATUS_WSP_FAILED:
              // 各エラー表示
              switch (response.data.async_code) {
                case error.WSP_117_ABNORMAL_PRESSURE_SENSOR_VALUE:
                  // 圧力センサ値異常
                  this.phase = PHASE.SENSOR_ABNORMALITY;
                  break;
                default:
                  // 該当のエラーコードが存在しない場合、共通エラー
                  this.showUnexpectedError();
                  break;
              }
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** セッション移行済判定 */
    async sessionStatusJudgement() {
      try {
        this.isLoading = true;
        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.READ,
        };

        // 初期処理（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              if (response.data.user_data.is_session) {
                // NonDefaultSession遷移
                await this.doStart(false);
              } else {
                // セキュリティアクセス判定
                await this.doSecAccess(false);
              }
              break;
            case config.STATUS_WSP_FAILED:
              // 共通エラー
              this.showUnexpectedError();
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * セキュリティアクセス判定
     * @param {boolean} isStart 開始時処理かどうか
     */
    async doSecAccess(isStart) {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.SEC_ACCESS
        };

        // 初期処理（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              if (isStart) {
                this.phase = PHASE.START_SURVEILLANCE;
                // 実行～実行監視
                await this.doExecute(API_TYPE.EXECUTE_START);
              } else {
                this.phase = PHASE.END_SURVEILLANCE;
                // 実行～実行監視
                await this.doExecute(API_TYPE.EXECUTE_END);
              }
              break;
            case config.STATUS_WSP_FAILED:
              // 共通エラー
              this.showUnexpectedError();
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * ルーチン処理
     * @param {string} apiStatus APIの種類
     */
    async doExecute(apiStatus) {
      try {

        this.isLoading = true;
        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: apiStatus,
        };

        // 初期処理（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );


        if (!response) {
          return;
        }

        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            switch (apiStatus) {
              case API_TYPE.EXECUTE_START:
                // メンテナンスモード開始表示
                this.phase = PHASE.START_DISPLAY;
                break;
              case API_TYPE.EXECUTE_END:
                await this.endCheck();
                if (this.phase !== PHASE.ERROR) {
                  // メンテナンスモード終了表示
                  this.phase = PHASE.END_DISPLAY;
                }
                break;
              default:
                this.showUnexpectedError();
                break;
            }
            break;
          case config.STATUS_WSP_FAILED:
            switch (response.data.async_code) {
              case error.WSP_117_UNABLE_TO_START_OR_EXIT_MAINTENANCE_MODE:
                switch (apiStatus) {
                  case API_TYPE.EXECUTE_START:
                    // メンテナンスモード開始不可表示
                    this.phase = PHASE.START_FAILED;
                    break;
                  case API_TYPE.EXECUTE_END:
                    // メンテナンスモード終了不可表示
                    this.phase = PHASE.END_FAILED;
                    break;
                  default:
                    this.showUnexpectedError();
                    break;
                }
                break;
              default:
                // 該当のエラーコードが存在しない場合、共通エラー
                this.showUnexpectedError();
                break;
            }
            break;
          default:
            this.showUnexpectedError();
            break;
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** DefaultSession遷移 */
    async endCheck() {
      try {

        this.isLoading = true;
        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.TERMINATE,
        };

        // 初期処理（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          if (this.phase === PHASE.ERROR) {
            // 機能終了
            return;
          }
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              break;
            case config.STATUS_WSP_FAILED:
              switch (response.data.async_code) {
                case error.WSP_GENERAL_ERROR:
                default:
                  // 該当のエラーコードが存在しない場合、共通エラー
                  this.showUnexpectedError();
                  break;
              }
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Dispose処理
     */
    async doDispose() {
      try {
        this.isLoading = true;
        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.DISPOSE,
        };

        // 初期処理（要求）
        await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; /** this.showUnexpectedError(); */ },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * StandbyAPIがポジティブレスポンスの時のレスポンス判定
     * @param {object} status 
     */
    successResponseStandby(status) {
      switch (status) {
        case RESPONSE_STATUS.START:
          // メンテナンスモード開始確認表示に遷移
          this.phase = PHASE.MAINTENANCE_START_CONFIRMATION;
          break;
        case RESPONSE_STATUS.END:
          // メンテナンスモード終了確認表示に遷移
          this.phase = PHASE.MAINTENANCE_END_CONFIRMATION;
          break;
        default:
          this.showUnexpectedError();
          break;
      }
    },

    // ユーザ操作
    /** メンテナンスモード開始確認表示 OK押下処理 */
    onMaintenanceStartConfirmationOkClicked() {
      this.phase = PHASE.MAINTENANCE_MODE_START;
    },

    /** メンテナンスモード終了確認表示 OK押下処理 */
    onMaintenanceEndConfirmationOkClicked() {
      this.phase = PHASE.MAINTENANCE_MODE_END;
    },

    /** メンテナンスモード開始 OK押下処理 */
    onMaintenanceModeStartOkClicked() {
      this.doStart(true);
    },

    /** メンテナンスモード終了 OK押下処理 */
    onMaintenanceModeEndOkClicked() {
      this.phase = PHASE.MOUNTED_CONFIRMATION;
    },

    /** 正規搭載確認画面 OK押下処理 */
    onMountedConfirmationOkClicked() {
      this.phase = PHASE.SENSOR_VALUE;
      this.sensorValueJudgement();
    },

    /** 正規搭載確認画面 キャンセル押下処理 */
    checkCancel() {
      this.phase = PHASE.CANCEL;
      this.errorClose();
    },

    /** メンテナンスモード開始表示 OKボタン押下 */
    onMaintenanceModeStartFinishClicked() {
      this.exit();
    },

    /** メンテナンスモード終了表示 OKボタン押下 */
    onMaintenanceModeEndFinishClicked() {
      this.exit();
    },

    /** メンテナンスモード開始不可表示,メンテナンスモード終了不可表示,圧力センサ値異常表示  OKボタン押下 */
    async onOtherErrorOkClicked() {
      await this.endCheck();
      if (this.phase !== PHASE.ERROR) {
        this.exit();
      }
    },

    /** エラー画面 OK押下処理 */
    async onErrorOkClicked() {
      if (this.isCompletedNds) {
        await this.endCheck();
      }
      this.exit();
    },

    /** キャンセル押下処理 */
    onCancelClicked() {
      this.exit();
    },

    /** エラー画面 終了処理 */
    async errorClose() {
      await util.sleep(this.waitTime);
      this.exit();
    },

    /**
     * 機能終了処理
     */
    async exit() {
      await this.doDispose();
      this.closeWizard();
    },

  },

  async mounted() {
    this.init();
    this.start();
  }
};
